import React, { useState } from 'react';
import { Users, Calendar, Share2, Briefcase } from 'lucide-react';
import { volunteerHubItems as mockVolunteerHubItems } from '../../data/mockData';
import OfferingCard from '../../components/OfferingCard';

const VOLUNTEER_HERO_IMG = '/images/volunteer-hub-hero.jpeg';

const OTHER_WAYS = [
  { id: 'event-support', label: 'Event Support', icon: Calendar },
  { id: 'skills-sharing', label: 'Skills Sharing', icon: Share2 },
  { id: 'community-outreach', label: 'Community Outreach', icon: Users },
  { id: 'administrative-support', label: 'Administrative Support', icon: Briefcase }
];

export default function VolunteerHub({ items, savedIds, onToggleSave, onSelectOpportunity, onExpressInterest }) {
  const volunteerHubItems = items || mockVolunteerHubItems;
  const [showAll, setShowAll] = useState(false);
  return (
    <div data-testid="volunteer-hub">
      {/* Hero */}
      <div className="p-4 desktop-shell md:pt-6">
        <div
          className="relative rounded-2xl overflow-hidden h-[150px] md:h-[220px]"
          data-testid="volunteer-hero"
          style={{ backgroundColor: '#0F9488' }}
        >
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-[55%] pl-5 md:pl-10 z-10">
              <h2 className="text-2xl md:text-3xl font-extrabold text-white leading-tight">Make a Difference Together</h2>
              <p className="text-xs md:text-base text-white/80 mt-1.5 md:mt-2.5 leading-snug">Volunteer today. Build a stronger community.</p>
            </div>
            <img
              src={VOLUNTEER_HERO_IMG}
              alt=""
              className="absolute right-0 bottom-0 h-full w-[55%] object-cover object-bottom"
            />
          </div>
        </div>
      </div>

      {/* Volunteer Opportunities */}
      <div className="px-4 pb-2 desktop-shell" data-testid="volunteer-opportunities">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base md:text-lg font-bold text-[#0F172A]">Volunteer Opportunities</h2>
          <button
            type="button"
            data-testid="volunteer-see-all"
            onClick={() => setShowAll((v) => !v)}
            className="text-xs font-semibold text-primary"
          >
            {showAll ? 'Show Less' : 'See All'}
          </button>
        </div>
        <div className={`gap-3 md:gap-5 pb-1 ${
          showAll
            ? 'grid grid-cols-2 md:grid-cols-4'
            : 'flex md:grid md:grid-cols-4 overflow-x-auto scrollbar-hide'
        }`}>
          {volunteerHubItems.map((op) => (
            <div
              key={op.id}
              className={showAll ? 'w-full' : 'shrink-0 w-[132px] md:w-auto'}
            >
              <OfferingCard
                item={op}
                isSaved={savedIds.has(op.id)}
                onToggleSave={onToggleSave}
                onClick={() => onSelectOpportunity(op)}
                testId={`volunteer-card-${op.id}`}
                saveTestId={`volunteer-save-${op.id}`}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Other Ways to Volunteer */}
      <div className="px-4 pb-6 desktop-shell" data-testid="other-ways-to-volunteer">
        <h2 className="text-base md:text-lg font-bold text-[#0F172A] mb-3">Other Ways to Volunteer</h2>
        <div className="grid grid-cols-4 md:grid-cols-4 lg:w-2/3 gap-2 md:gap-4">
          {OTHER_WAYS.map((w) => {
            const Icon = w.icon;
            return (
              <button
                key={w.id}
                type="button"
                data-testid={`other-way-${w.id}`}
                onClick={() => onExpressInterest?.(w.id, w.label)}
                className="flex flex-col items-center gap-1.5"
              >
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                  <Icon className="h-5 w-5 md:h-6 md:w-6" />
                </div>
                <span className="text-[10px] md:text-xs font-medium text-center leading-tight text-foreground">{w.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
